import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";
import { httpPost } from "../../../../../Utils/apis/apis";
import { fetchSalesTrackerSubmitFlag } from "./layout.Helper.js";
import A_Button from "../../../Atoms/Inputs/Buttons/A_Button.jsx";
import A_SecuredAction from "../../../Atoms/Security/A_SecuredAction";
import { pageSecurityActions } from "../../../../../Utils/Helpers/pageSecurity";

const FooterSubmitButton = ({ footer, parentThis, setToast, getCurrentPage }) => {
  const [isExecuting, setIsExecuting] = useState(false);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(true);

  useEffect(() => {
    const checkFlag = async () => {
      const loanId = parentThis?.props?.params?.crmId;
      if (loanId && footer?.content?.button?.disabledRequired) {
        const flag = await fetchSalesTrackerSubmitFlag(loanId);
        setIsSubmitEnabled(flag);
      }
    };
    checkFlag();
  }, [parentThis?.props?.params?.crmId, footer?.content?.button?.btnLabel, footer?.content?.button?.disabledRequired]);

  const handleFooterButtonClick = async () => {
    if (footer?.content?.button?.SpName) {
      setIsExecuting(true);
      try {
        const payload = [
          {
            id: footer?.content?.button?.SpName || "UpdateLTGDV",
            spName: footer?.content?.button?.SpName || "DF.usp_RecalculateLTGDV",
            parameters: {
              loanId: parentThis.props?.params?.crmId,
              ExecutedBy:
                parentThis.props?.currentUser?.email ||
                parentThis.props?.currentUser?.name,
            },
          },
        ];
        const response = await httpPost(
          `/SqlData/executeStoredProcedure`,
          payload
        );
        if (response?.[0]?.value) {
          if (typeof setToast === "function") {
            setToast({
              type: "success",
              severity: "success",
              message:
                response?.[0]?.value || "Operation completed successfully",
              status: true,
              duration: 5000,
            });
          }
          const { pageUrl, crmId } = parentThis?.props?.params || {};
          if (pageUrl && crmId && typeof getCurrentPage === "function") {
            getCurrentPage({ pageUrl, crmId });
          }
        } else {
          if (typeof setToast === "function") {
            setToast({
              type: "error",
              severity: "error",
              message:
                response?.response?.data?.Message ||
                "Something went wrong while performing the operation",
              status: true,
              duration: 5000,
            });
          }
        }
      } catch (error) {
        if (typeof setToast === "function") {
          setToast({
            type: "error",
            severity: "error",
            message:
              error?.message ||
              "Something went wrong while performing the operation",
            status: true,
            duration: 5000,
          });
        }
      } finally {
        setIsExecuting(false);
      }
    }
  };

  return (
    <A_SecuredAction permission={pageSecurityActions.UPDATE}>
      <A_Button
        label={footer?.content?.button?.btnLabel}
        endIcon={isExecuting ? <CircularProgress size={20} /> : null}
        disabled={isExecuting || !isSubmitEnabled}
        onClick={handleFooterButtonClick}
        premiumVariant="secondary"
        size="small"
      />
    </A_SecuredAction>
  );
};

FooterSubmitButton.propTypes = {
  footer: PropTypes.object.isRequired,
  parentThis: PropTypes.object.isRequired,
  setToast: PropTypes.func,
  getCurrentPage: PropTypes.func,
};

export default FooterSubmitButton;
